import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { payCyclesService, UpdatePayCycleRequest } from '@aslanpay/portal-common-lib';

const useUpdatePayCycle = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, UpdatePayCycleRequest>) => {
  return useMutation<unknown, Error, UpdatePayCycleRequest>(
    ({ id, payCalendarId, cutoffDate, payday, odpAllowancePercentage }: UpdatePayCycleRequest) =>
      payCyclesService.updatePayCycle({
        id,
        payCalendarId,
        cutoffDate,
        payday,
        odpAllowancePercentage,
      }),
    { onSuccess, onError }
  );
};

export default useUpdatePayCycle;
